import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitRoot } from '@cian/ui-kit';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { Faq } from 'shared/components/Faq';
import { Header } from 'shared/components/Header';
import { StartBlock } from 'shared/components/StartBlock';
import { Utp } from 'shared/components/Utp';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { IncreaseImpressionsContainer } from '../IncreaseImpressions';
import { NoSsr } from '@cian/react-utils';
import { ServicesTypesTable } from 'shared/components/ServicesTypesTable';
import { MoreEffectiveContainer } from '../MoreEffective';
import { Footer } from 'shared/components/Footer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <Header />
            <StartBlock />
            <Utp />
            <NoSsr>
              <IncreaseImpressionsContainer />
            </NoSsr>
            <MoreEffectiveContainer />
            <ServicesTypesTable />
            <Faq />
            <Footer />
          </Provider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
